import Dialog from '@mui/material/Dialog';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import EditForm from './components/EditForm/EditForm';

const RoleEditForm = (props) => {
  const { onClose, open, data, getData, visibility } = props;
  const TextFieldStyle = {
    paddingTop: 2,
    paddingLeft: 15,
    paddingRight: 15,
    fontSize: '13px'
  };

  const LabelStyle = {
    paddingLeft: 15,
    paddingRight: 15,
    fontSize: '13px'
  };

  const DialogWrapper = styled(Dialog)(
    () => `
          .MuiDialog-container {
              height: 100vh;
          }
          
          .MuiDialog-paperScrollPaper {
              max-height: calc(100vh - 80px);
          }
      `
  );

  return (
    <DialogWrapper
      open={open}
      keepMounted
      fullWidth
      maxWidth="md"
      scroll="paper"
      onClose={onClose}
    >
      <EditForm
        LabelStyle={LabelStyle}
        TextFieldStyle={TextFieldStyle}
        onClose={onClose}
        data={data}
        getData={getData}
        visibility={visibility}
      />
    </DialogWrapper>
  );
};

RoleEditForm.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  role: PropTypes.object.isRequired,
  setRoles: PropTypes.func.isRequired,
  roles: PropTypes.array.isRequired,
  data: PropTypes.object.isRequired,
  getData: PropTypes.any,
  visibility: PropTypes.bool
};

export default RoleEditForm;
